<template lang='pug'>
  span
    v-chip(x-small v-for='tag in value' :key='tag' @click.stop='tagClicked(tag)')
      | {{tag}}
</template>

<script>

export default {
  name: 'DisplayTags',
  props: {
    value: {
      default() {
        return [];
      }
    }
  },
  methods: {
    tagClicked(tag) {
      this.$emit('tag', tag);
    }
  }
};
</script>

<style scoped>

</style>
